enum ResourceType {
  PLANTS,
  ISSUES,
  PERFORMANCES,
  TICKETS,
}

export default ResourceType;
